// extracted by mini-css-extract-plugin
module.exports = {"terms":"FiberInterestCityOfficialForm_terms__9UDYu"};